const RATING_VALUES = [1, 2, 3, 4, 5];
function isObject(value) {
  return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function isString(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number" && !Number.isNaN(value);
}
function isRating(value) {
  return typeof value === "number" && RATING_VALUES.includes(value);
}
export {
  isNumber,
  isObject,
  isRating,
  isString
};
//# sourceMappingURL=utils.js.map
